import logo from 'assets/images/logo.png';
import { Link } from 'react-router-dom';
import { useData } from 'context/DataContext'
import { signOut, auth } from 'config/Firebase'

const Header = () => {
  const { user } = useData();

  const logout = () => {
    signOut(auth).then(() => {})
  }
  return (
    <header className="web_header">
      <div className="cs_container">
        <div className="cs_row">
          <div className="header_logo">
            <Link to="/"><img src={logo} alt="Smash Code" /></Link>
          </div>
          {user?.isAuth &&
          <div className="header_right">
            {/* <Link className="cs_btn" to="/dashboard">Dashboard</Link> */}
            <button onClick={logout} className="cs_btn">Logout</button>
          </div>}
        </div>
      </div>
    </header>
  )
}

export default Header